/**
 * Whether the report renders the Job Summary (and its NOTES page).
 *
 * Roof-Claim-only deal (pre-deploy QA, Nov 1 2026): the Job Summary prices the
 * alarm / home-improvement equipment and carries the alarm "Monitoring
 * service: $9.99/mo" line (V46). A customer whose only product is Roof Claim
 * has none of that, so the page printed an empty table, "Total: $0.00" and the
 * monitoring line. Same product-scope rule as the Smart Home videos (B193,
 * `smartHomeVideosVisible`): an explicit Roof-Claim-only scope drops the
 * section.
 *
 * Kept on purpose:
 * - empty `products` (legacy "everything") with a historical claim: unchanged,
 *   it may still carry equipment priced before products existed (V92);
 * - a Job Summary signature already made: a signed page never disappears (V67);
 * - a guided-signing step on the Job Summary (e.g. an M+S agreement next to
 *   the claim): its buttons must exist or the guide skips Part 1.
 */
export const jobSummaryVisible = ({
  jobSummarySigned,
  products,
  reportSigningSteps,
  roofClaimShown,
}: {
  jobSummarySigned: boolean
  products: readonly string[]
  reportSigningSteps: boolean
  roofClaimShown: boolean
}): boolean =>
  !(
    roofClaimShown &&
    products.length > 0 &&
    products.every((product) => product === 'RC')
  ) ||
  jobSummarySigned ||
  reportSigningSteps
